import React, { useState } from "react";
import axios from "axios";
import { Container, Row, Col, Form, Button, Card} from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import logo from "./imeges/logo1.svg";
import NavBar from "./NavBar";
import { useTheme } from "./ThemeContext";
import Footer from "./Footer";
import Swal from "sweetalert2";


const trusted = [
  {id:1,imege:'https://picsum.photos/seed/picsum/100/100'},
  {id:2,imege:'https://picsum.photos/seed/picsum/100/100'},
  {id:3,imege:'https://picsum.photos/seed/picsum/100/100'},
  {id:4,imege:'https://picsum.photos/seed/picsum/100/100'},
  {id:5,imege:'https://picsum.photos/seed/picsum/100/100'},
  {id:6,imege:'https://picsum.photos/seed/picsum/100/100'},

]

const BookDemo = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    about: "",
    message: "",
  });

  // const [showSidebar, setShowSidebar] = useState(false);
  // const navigate = useNavigate();
  const {theme} = useTheme()

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate 'about' section selection
    if (!formData.about) {
      Swal.fire({
          title: "Select an Option",
          text: "Please select a  How do You Know Section",
          icon: "warning",
      });
      return;
  }
    axios
      .post("http://localhost:5000/api/BD/store-details", formData, {
        headers: { "Content-Type": "application/json" },
      })
      .then(() => {
        // alert("Demo request sent! You will receive a WhatsApp message shortly.");
           // Show a beautiful success popup
           Swal.fire({
            title: "🎉 Booking Confirmed!",
            text: "We’ll contact you shortly. ",
            icon: "success",
            background: "#E2E8F0",
            color: "#ffffff",
            confirmButtonColor: "#4CAF50",
            confirmButtonText: "Awesome!",
            imageUrl: logo,
            imageWidth: 150,
            imageHeight: 150,
        });
        setFormData({ name: "", email: "", number: "", about: "", message: "" });      })
      .catch(() => {
        // alert("Something went wrong. Please try again.");
            Swal.fire({
            title: "Currently Not Avilable",
            // text: "We’ll contact you shortly. ",
            // icon: "success",
            background: "#E2E8F0",
            color: "#ffffff",
            confirmButtonColor: "#4CAF50",
            confirmButtonText: "Return",
            imageUrl: logo,
            imageWidth: 150,
            imageHeight: 150,
        });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only numbers for the 'number' field and limit to 10 digits
    if (name === "number" && !/^\d*$/.test(value)) return;
    if (name === "number" && value.length > 10) return;

    setFormData({ ...formData, [name]: value });
};



  return (
    <div>
    

      {/* Navbar */}
      {/* <Navbar variant="dark" fixed="top" style={{ backgroundColor: "#001351" }}> */}
       
          {/* Logo */}
          {/* <Navbar.Brand href="#">
            <img src={logo} width="90" height="60" alt="IT Company logo" />
          </Navbar.Brand> */}

          {/* Navbar Links (Show Only on Large Screens) */}
          {/* <Nav className="ml-auto d-none d-lg-flex justify-content-start">
            <Nav.Link onClick={() => navigate("/")} style={{ color: "white" }}>Home</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("services")} style={{ color: "white" }}>Products</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("about")} style={{ color: "white" }}>About</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("contact")} style={{ color: "white" }}>Contact</Nav.Link>
          </Nav> */}

          {/* Toggle Button (Show Only on Small and Medium Screens) */}
          {/* <Button variant="outline-light" className="d-lg-none" onClick={() => setShowSidebar(true)}>
            ☰
          </Button> */}
     
      {/* </Navbar> */}
      <NavBar />

      {/* Sidebar Offcanvas (Only for Small & Medium Screens) */}
      {/* <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link onClick={() => navigate("/")} style={{ color: "#001351" }}>Home</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("services")} style={{ color: "#001351" }}>Products</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("about")} style={{ color: "#001351" }}>About</Nav.Link>
            <Nav.Link onClick={() => handleNavClick("contact")} style={{ color: "#001351" }}>Contact</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* Main Content */}
      <Container fluid className=""  style={{
      backgroundColor: theme === "dark" ? "#1e1e1e" : "",
      minHeight: "100vh", marginTop:'40px'
    }}>
        <Row className="justify-content-center align-items-center py-5">
          {/* Left Content */}
          <Col lg={5} md={6} className="px-4">
            <h2>Meet with our team & get full access to all features for 14 days</h2>
            <p>Find out how Flare can consolidate tooling, reduce the risk of breaches, and provide unmatched visibility into your organization's data exposure.</p>
            <h5>TRUSTED BY</h5>
            <div className="d-flex flex-wrap mt-3">
              {/* {[...Array(5)].map((_, i) => (
                <img key={i} src={`https://picsum.photos/seed/picsum/100/100`} alt={`Logo ${i + 1}`} className="m-2" />
                

              ))} */}
              {trusted.map((trust)=>(
                <img key={trust.id} src={trust.imege} alt={`${trust.id}not definted`}  className="m-2"/>
              ))}
            </div>
          </Col>

          {/* Right Form */}
          <Col lg={5} md={6}>
            <Card className="shadow p-4">
              <Card.Body>
                <h3 className="text-center">Meet with our Team</h3>
                <Form className="mt-3" onSubmit={handleSubmit}>
            {["name", "email", "number", "message",].map((field, idx) => (
                <Form.Group className="mb-3" key={idx}>
                    <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}*</Form.Label>
                    <Form.Control
                        type={
                            field === "message" ? "textarea" 
                            : field === "email" ? "email" 
                            : "text"
                        }
                        placeholder={`Enter ${field}`}
                        value={formData[field]}
                        onChange={handleChange}
                        name={`${field}`}
                        required
                        maxLength={field === "number" ? 10 : undefined} // Limit number input to 10 digits
                    />
                </Form.Group>
            ))}

            {/* About Section (Dropdown) */}
            <Form.Group className="mb-3">
                <Form.Label>How do you knows *</Form.Label>
                <Form.Select 
                    value={formData.about} 
                    onChange={handleChange} 
                    name="about"
                    required
                  
                >
                    {/* <option value="">How do you knows</option> */}
                    <option value="website">Website</option>
                    <option value="Lindkedin">Linkedin</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Facebook">Facebook</option>
                    <option value="others">others</option>


                </Form.Select>
            </Form.Group>

            <Button variant="danger" type="submit" className="w-100">
                Request a Demo
            </Button>
        </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default BookDemo;
